export default "__VITE_ASSET__J0sPrc65__"